"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _config = require("webmotors-react-pj/config");
var _utils = require("webmotors-react-pj/utils");
var _config2 = _interopRequireDefault(require("webmotors-react-pj/i18n/config"));
var _style = require("webmotors-react-pj/frame/header/logged/items/intercom/style");
var _v = _interopRequireDefault(require("webmotors-react-pj/tag-analytics/v2"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = () => {
  const refWrapper = (0, _react.useRef)();
  const handleAnalyticEvent = () => {
    (0, _v.default)('pj_cockpit_iconeChat', {
      site: {
        subEnvironment: 'homepage'
      },
      page: {
        flowType: 'cockpit',
        pageType: 'cockpit-homepage',
        pageName: '/webmotors/cockpit/homepage',
        'pageName.tier1': 'cockpit',
        'pageName.tier2': 'homepage',
        'pageName.tier3': undefined,
        loadTime: window.performance.timing.navigationStart
      }
    });
  };
  (0, _react.useEffect)(() => {
    setTimeout(() => {
      const refWrapperCurrent = refWrapper.current;
      const classNameIntercom = refWrapperCurrent && [...refWrapperCurrent.classList][0];
      const jwt = (0, _utils.jwtGet)();
      const appId = _config2.default.header.settings.intercomId;
      const {
        email,
        nameid: name,
        sid
      } = jwt;
      const w = window;
      const ic = w.Intercom;
      w.intercomSettings = {
        name,
        email,
        user_id: sid,
        app_id: appId,
        custom_launcher_selector: ".".concat(classNameIntercom),
        alignment: 'right',
        created_at: Date.now(),
        horizontal_padding: 0,
        vertical_padding: 0
      };
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        const d = document;
        const i = () => i.c(arguments);
        const l = () => {
          const s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = "https://widget.intercom.io/widget/".concat(appId);
          const x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        i.q = [];
        i.c = args => i.q.push(args);
        w.Intercom = i;
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
      w.Intercom('boot', {
        app_id: appId,
        email,
        user_id: sid,
        created_at: Date.now()
      });
      w.intercomTimeout = w.setTimeout(() => w.clearInterval(w.intercomInterval), 30000);
      w.intercomInterval = w.setInterval(() => {
        if (!!w.Intercom && w.Intercom.booted) {
          clearInterval(w.intercomInterval);
          clearTimeout(w.intercomTimeout);
          w.Intercom('onUnreadCountChange', unreadCount => {
            const count = unreadCount <= 9 ? unreadCount : '9+';
            const notify = window.document.getElementById('intercom-notify');
            if (count && notify) {
              notify.innerText = count;
            }
          });
        }
      }, 300);
    }, 3000);
  }, []);
  return _react.default.createElement(_style.StyleWrapper, {
    ref: refWrapper
  }, _react.default.createElement(_style.StyleImg, {
    alt: "Intercom",
    onClick: () => handleAnalyticEvent(),
    "aria-hidden": "true",
    src: "".concat(_config.UrlCockpit, "/assets/img/icons/letter-double.svg")
  }));
};
exports.default = _default;